/* Mobile bottom bar.
   Every slot drives UI the theme already owns — the header's drawer toggles and
   the product section's real add-to-cart button — so there is no second copy of
   that logic to keep in sync. */
(function () {
  "use strict";

  var bar = document.querySelector("[data-mbar]");
  if (!bar) return;

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Slots that defer to the header ---------------------------------- */

  var shopBtn = bar.querySelector("[data-mbar-shop]");
  if (shopBtn) {
    shopBtn.addEventListener("click", function () {
      var navToggle = document.querySelector("[data-nav-toggle]");
      if (!navToggle) return;
      navToggle.click();

      /* Open straight onto the collections rather than making them tap twice. */
      var accordion = document.querySelector("[data-mega-drawer-toggle]");
      if (accordion && accordion.getAttribute("aria-expanded") !== "true") {
        setTimeout(function () { accordion.click(); }, 220);
      }
    });
  }

  var cartBtn = bar.querySelector("[data-mbar-cart]");
  if (cartBtn) {
    cartBtn.addEventListener("click", function () {
      var toggle = document.querySelector("[data-cart-toggle]");
      if (toggle) toggle.click();
    });
  }

  /* ---- Cart count ------------------------------------------------------- */

  var pip = bar.querySelector("[data-mbar-cart-count]");

  function syncCart() {
    if (!pip) return;
    var source = document.querySelector("[data-cart-count]");
    var n = source ? parseInt(source.textContent.trim(), 10) || 0 : 0;
    pip.textContent = String(n);
    pip.classList.toggle("is-on", n > 0);
  }

  syncCart();

  /* The header replaces its cart markup wholesale after an add, so watch the
     actions container rather than the count node, which may be swapped out. */
  var actions = document.querySelector(".site-header__actions");
  if (actions && "MutationObserver" in window) {
    new MutationObserver(syncCart).observe(actions, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  /* ---- Stay out of the way of drawers ----------------------------------- */

  function watchDrawer(selector) {
    var el = document.querySelector(selector);
    if (!el || !("MutationObserver" in window)) return;
    new MutationObserver(function () {
      var anyOpen = !!document.querySelector(
        "[data-nav-drawer].is-open, [data-cart-drawer].is-open"
      );
      document.body.classList.toggle("mbar-suppressed", anyOpen);
    }).observe(el, { attributes: true, attributeFilter: ["class"] });
  }

  watchDrawer("[data-nav-drawer]");
  watchDrawer("[data-cart-drawer]");

  /* ---- Hide on scroll down, return on scroll up ------------------------- */

  var lastY = window.scrollY;
  var ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY;
      var delta = y - lastY;

      /* Ignore rubber-banding at either end, and small jitter. */
      if (y > 120 && Math.abs(delta) > 6) {
        bar.setAttribute("data-hidden", delta > 0 ? "true" : "false");
      } else if (y <= 120) {
        bar.setAttribute("data-hidden", "false");
      }

      lastY = y;
      ticking = false;
    });
  }

  if (!reduce) window.addEventListener("scroll", onScroll, { passive: true });

  /* ---- Contextual add to cart ------------------------------------------- */

  var atc = bar.querySelector("[data-mbar-atc]");
  var realCta = document.querySelector("[data-product-cta]");

  if (atc && realCta) {
    var atcLabel = atc.querySelector("[data-mbar-atc-label]");

    function mirror() {
      var srcLabel = realCta.querySelector("[data-product-cta-label]");
      var priceEl = document.querySelector("[data-product-price]");
      var text = srcLabel ? srcLabel.textContent.trim() : "Add to bag";
      var disabled = realCta.hasAttribute("disabled");

      if (!disabled && priceEl && priceEl.textContent.trim()) {
        text += " · " + priceEl.textContent.trim();
      }

      if (atcLabel) atcLabel.textContent = text;
      atc.disabled = disabled;
    }

    mirror();

    if ("MutationObserver" in window) {
      new MutationObserver(mirror).observe(realCta, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true
      });

      var priceHost = document.querySelector("[data-product-price]");
      if (priceHost) {
        new MutationObserver(mirror).observe(priceHost, {
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }

    atc.addEventListener("click", function () {
      realCta.click();
    });

    /* Expand only once the real button has scrolled away. */
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var show = !entry.isIntersecting;
            bar.setAttribute("data-atc", show ? "on" : "off");
            atc.setAttribute("aria-hidden", show ? "false" : "true");
            atc.tabIndex = show ? 0 : -1;
          });
        },
        { rootMargin: "0px 0px -60px 0px" }
      ).observe(realCta);
    }
  }

  /* ---- Search sheet ------------------------------------------------------ */

  var panel = document.querySelector("[data-mbar-search-panel]");
  var searchBtn = bar.querySelector("[data-mbar-search]");

  if (panel && searchBtn) {
    var input = panel.querySelector("[data-mbar-search-input]");
    var results = panel.querySelector("[data-mbar-search-results]");
    var closeBtn = panel.querySelector("[data-mbar-search-close]");
    var base = bar.getAttribute("data-predictive-url") || "/search/suggest";
    var timer = null;
    var lastQuery = "";

    function openSearch() {
      panel.hidden = false;
      requestAnimationFrame(function () { panel.classList.add("is-open"); });
      searchBtn.setAttribute("aria-expanded", "true");
      document.body.classList.add("mbar-suppressed");
      setTimeout(function () { if (input) input.focus(); }, 80);
    }

    function closeSearch() {
      panel.classList.remove("is-open");
      searchBtn.setAttribute("aria-expanded", "false");
      document.body.classList.remove("mbar-suppressed");
      setTimeout(function () { panel.hidden = true; }, 240);
      searchBtn.focus();
    }

    searchBtn.addEventListener("click", openSearch);
    if (closeBtn) closeBtn.addEventListener("click", closeSearch);

    panel.addEventListener("click", function (e) {
      if (e.target === panel) closeSearch();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !panel.hidden) closeSearch();
    });

    function money(value) {
      var n = parseFloat(value);
      if (isNaN(n)) return "";
      /* Prices here are whole rupees; Indian digit grouping. */
      return "₹" + Math.round(n).toLocaleString("en-IN");
    }

    /* Titles and URLs go into innerHTML, so escape them rather than trusting
       that no product is ever named with an ampersand or a quote. */
    function esc(value) {
      return String(value == null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    }

    function render(products, query) {
      if (!products.length) {
        results.innerHTML =
          '<p class="mbar-search__note">No matches for “' + esc(query) + '”</p>';
        return;
      }

      results.innerHTML = products
        .map(function (p) {
          var img = p.featured_image ? p.featured_image.url : p.image;
          var price = p.price != null ? money(p.price) : "";
          return (
            '<a class="mbar-search__row" href="' + esc(p.url) + '">' +
            (img
              ? '<img class="mbar-search__thumb" src="' + esc(img) + '" alt="" loading="lazy" width="42" height="52">'
              : '<span class="mbar-search__thumb"></span>') +
            '<span class="mbar-search__name">' + esc(p.title) + "</span>" +
            (price ? '<span class="mbar-search__price">' + price + "</span>" : "") +
            "</a>"
          );
        })
        .join("");
    }

    function query(q) {
      if (q === lastQuery) return;
      lastQuery = q;

      if (q.length < 2) {
        results.innerHTML = "";
        return;
      }

      fetch(
        base +
          ".json?q=" +
          encodeURIComponent(q) +
          "&resources[type]=product&resources[limit]=6",
        { headers: { Accept: "application/json" } }
      )
        .then(function (r) {
          if (!r.ok) throw new Error("search failed");
          return r.json();
        })
        .then(function (data) {
          var products =
            (data.resources && data.resources.results && data.resources.results.products) || [];
          render(products, q);
        })
        .catch(function () {
          results.innerHTML =
            '<p class="mbar-search__note">Couldn\'t load results. Press enter to search.</p>';
        });
    }

    if (input) {
      input.addEventListener("input", function () {
        clearTimeout(timer);
        var q = input.value.trim();
        timer = setTimeout(function () { query(q); }, 180);
      });
    }
  }
})();
